import { render, staticRenderFns } from "./InsuranceBridgeRecipeDeliveryForm.vue?vue&type=template&id=eddb6020&scoped=true&"
import script from "./InsuranceBridgeRecipeDeliveryForm.vue?vue&type=script&lang=js&"
export * from "./InsuranceBridgeRecipeDeliveryForm.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceBridgeRecipeDeliveryForm.vue?vue&type=style&index=0&id=eddb6020&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eddb6020",
  null
  
)

export default component.exports